import React from "react";
import {wordCheckEvent} from "utils/wordCheckUtils";

const TextInputBox = ({id, max, className, hint, defaultValue, wordType}) => {
  let value = defaultValue || ""

  return (
    <input
      type="text"
      id={id}
      className={`fw-5 ${className}`}
      maxLength={max}
      defaultValue={`${value}`}
      key={`${value}`}
      placeholder={hint}
      autoComplete="off"
      onInput={(e) => wordCheckEvent(e, wordType)}
    />
  );
}

export default TextInputBox;